<template>
  <div class="item-refund-reasons">
    <el-select
        :value="selectedReason"
        class="item-refund-reason-select"
        placeholder="Select refund reason"
        popper-class="item-refund-reason-dropdown"
        @change="emitSelected">
      <el-option
          v-for="reason in refundReasons"
          :key="reason.id"
          class="item-refund-reason-option"
          :label="reason.text"
          :value="reason.id">
        <span style="float: left">{{ reason.text }}</span>
        <span
            v-if="selectedReason === reason.id && showCheckMark"
            style="float: right !important;"><img
                style="height: 12.28px; width: 15.78px; padding-top: 5px"
                :src="icons.dropDownCheckmark"
                alt="selected"></span>
      </el-option>
    </el-select>
  </div>
</template>

<script scoped>
export default {
  name: "ItemRefundReasons",
  props: {
    selectedReason: {
      type: Number,
      default: null,
    },
    refundReasons: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      showCheckMark: false,
      icons: {
        dropDownCheckmark: require("@/assets/drop-down-checkmark.svg"),
      },
    };
  },
  watch: {
    selectedReason: function () {
      this.showCheckMark = this.selectedReason != null;
    },
  },
  mounted() {
    this.showCheckMark = this.selectedReason != null;
  },
  methods: {
    emitSelected(value) {
      this.$emit("selected-reason", value);
    },
  },
};
</script>

<style scoped>
.item-refund-reasons {
  display: flex;
  align-self: center;
  width: 320px;
  .el-select {
    display: flex;
    align-items: center;
  }
  .el-input__inner {
    font-family: "Equip", serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    display: flex;
    align-items: center;
    color: #424242 !important;
  }
  .el-select-dropdown el-popper {
    color: #424242;
  }
  .el-select-dropdown__item {
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    font-family: "Equip";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
  }
  .el-select-dropdown__list {
    padding: 8px 0;
  }
}
.item-refund-reason-option {
  height: 40px !important;
  align-items: center !important;
  padding: 8px 16px !important;
  font-family: "Equip", serif !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 24px !important;
}
.item-refund-reason-option:hover {
  background-color: #eff8fc !important;
}
.item-refund-reason-select {
  .el-input__inner:focus {
    border: 2px solid #1998d5;
  }
}
.item-refund-reason-dropdown {
  padding: 8px 0 !important;
  border: 1px solid #81919f !important;
  .popper__arrow {
    display: none !important;
  }
  .popper__arrow::after {
    display: none !important;
  }
}
.item-refund-reason-option.selected {
  color: #1476ad !important;
}
</style>
